/**
 * Publish HTML sanitizer — a single choke-point for rendering post bodies
 * so we never pipe raw user HTML into `dangerouslySetInnerHTML` or
 * `element.innerHTML`.
 *
 * We whitelist the exact set of tags & attributes the composer's toolbar
 * can produce (bold, italic, headings, lists, blockquote, links, plus
 * `<br>` / `<p>` for line breaks). Anything else — `<script>`, event
 * handlers, `javascript:` URLs, `<iframe>`, inline styles — is stripped.
 * Links always open in a new tab with `rel="noopener noreferrer"`.
 */
import DOMPurify from "dompurify";

const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "div", "span",
    "b", "strong", "i", "em", "u",
    "h1", "h2", "h3", "h4",
    "ul", "ol", "li",
    "blockquote",
    "a",
  ],
  ALLOWED_ATTR: ["href", "target", "rel"],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "link", "meta"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "style"],
};

// Force safe rel on outbound links.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizePostHtml(dirty) {
  if (!dirty) return "";
  return DOMPurify.sanitize(String(dirty), CONFIG);
}
